import styled from 'styled-components';
import _Confetti from 'react-confetti';

export const Confetti = ({ size }: { size: [number, number] }) => {
  return (
    <ConfettiContainer>
      <StyledConfetti numberOfPieces={300} width={size[0]} height={size[1]} />
    </ConfettiContainer>
  );
};

const ConfettiContainer = styled.div`
  pointer-events: none !important;
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;

  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity 0.5s ease-in-out;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
`;

const StyledConfetti = styled(_Confetti)`
  will-change: opacity;
  position: absolute;
  z-index: 100 !important;
`;
